export const ACTION_PROFILE_DROPDOWN = 'ProfileDropdown';
export const CATEGORY_HEADER = 'header';
export const CONSUMER_DROPDOWN_HOVER_LABEL = 'ViewFromConsumer';
